<template lang="html">
  <div class="scroll-out" style="height:calc(100vh - 110px);width:100%;">
    <div class="d-flex align-items-center justify-content-between">
      <div class="text-primary cta-3">
        Total : <b>{{ filtered_review_set.totalCount }}</b> avis
      </div>

      <div v-if="parentPage != 'establishment'"
           class="w-100 w-lg-auto search-input-container border border-separator"
           style="background-color:#fff">
        <input class="form-control search"
               ref="searchBox"
               @input="updateSearchString"
               v-model="filters.search_string"
               type="text"
               autocomplete="off"
               placeholder="Rechercher"/>
        <span class="search-magnifier-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="1.5"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="acorn-icons acorn-icons-search undefined">
                        <circle cx="9" cy="9" r="7"></circle>
                        <path d="M14 14L17.5 17.5"></path>
                    </svg>
                </span>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div class="is-pulled-right pad ">
                <span class="icon"
                      v-if="loading">
                    <i class="fas fa-spinner fa-spin"></i>
                </span>
      </div>
    </div>

    <div ref="list" class="list scroll custom-scroll" style="flex-grow: 1;"
         v-if="!loading && filtered_review_set.results.length > 0" @scroll="handleScroll">
      <div v-for="item in filtered_review_set.results"
           @click="select(item.uid)">
        <div class="card mb-2 cursor-pointer hover-border-primary"
             :class="{'selected': item.uid === $store.state.selected_review_uid}">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="">
                                <span class="d-block text-primary">
                                    {{ item.published_on|local_date }}&nbsp;
                                </span>
              </div>
              <div class="d-flex">
                <div class="d-flex" style="height:20px;">
                  <div style="width:90px;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">
                    {{ item.platform.name }}
                  </div>
                  <div class="pe-1">{{ item.mark|round(1) }}</div>

                </div>
                <div class="d-flex pe-2">
                  <i class="icon-12 "
                     :class="{'text-success bi-hand-thumbs-up-fill':item.positive, 'text-danger bi-hand-thumbs-down-fill': !item.positive}"></i>
                </div>
              </div>
              <ReviewConsultantBox
                  v-if="item.establishment.consultant && parentPage != 'establishment'"
                  :avatar-src="backendUrl + item.establishment.consultant.avatar"
                  :fullname="item.establishment.consultant.fullname"/>
              <div class="d-flex flex-1 ms-2">
                                <span class="badge list-badge bg-pink text-uppercase custom-badge"
                                      v-if="item.current_state"
                                      :class="get_class(item.current_state.class_name)">
                                    {{ item.current_state.verbose_name }}
                                    {{ get_tag_name(item.current_state.tag) }}
                                </span>
                <span class="badge" v-else>NO STATE</span>
              </div>

            </div>
            <div class="col-12">
              <span class="clamp-line small" data-line="1"
                    v-if="[null, ''].indexOf(item.title_fr) < 0">{{ item.title_fr }}</span>
              <span class="clamp-line small" data-line="1"
                    v-else-if="[null, ''].indexOf(item.title_native) < 0">{{ item.title_native }}</span>
              <span class="clamp-line small" data-line="1" v-else>Pas de titre </span>
            </div>
            <div class="d-flex justify-content-between mt-1">
              <div class="w-100  d-flex align-items-center">
                <span class="d-block text-primary small ">{{ item.author }}</span>
              </div>
              <div v-if="parentPage != 'establishment'" class="w-100">
                                <span class="d-block text-end small" :title="item.establishment.name">
                                    <i v-if="item.establishment.custom_text_1 && item.establishment.custom_text_1.toLowerCase() === 'gîte'"
                                       class="icon-16 me-2 bi-shop"></i>
                                    <svg
                                        v-else-if="item.establishment.custom_text_1 && item.establishment.custom_text_1.toLowerCase() === 'restaurant'"
                                        class="icon-list me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path
                                        d="M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9L32 176c0 26.5 21.5 48 48 48l32 0 32 0c26.5 0 48-21.5 48-48l0-10.7c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2l0 10.7c0 44.2-35.8 80-80 80l-16 0 0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240-16 0c-44.2 0-80-35.8-80-80l0-10.7c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176l0 112c0 17.7 14.3 32 32 32l64 0 0-287.8-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32l0 288 0 16 0 16 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0c-35.3 0-64-28.7-64-64l0-112C288 32 400 0 416 0z"/></svg>
                                    <svg
                                        v-else-if="item.establishment.custom_text_1 && item.establishment.custom_text_1.toLowerCase() === 'camping'"
                                        class="icon-list me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path
                                        d="M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5L308.9 130.4 532.8 397.2C540 405.8 544 416.7 544 428l0 36c0 26.5-21.5 48-48 48l-208 0L80 512c-26.5 0-48-21.5-48-48l0-36c0-11.3 4-22.2 11.2-30.9L267.1 130.4 179.7 26.3c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2L288 105.5 371.7 5.7c5.7-6.8 15.8-7.7 22.5-2zM67.7 417.7c-2.4 2.9-3.7 6.5-3.7 10.3l0 36c0 8.8 7.2 16 16 16l49.9 0 1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9 49.9 0c8.8 0 16-7.2 16-16l0-36c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480L288 480l117.4 0L288 330 170.6 480z"/></svg>
                                    <svg
                                        v-else-if="item.establishment.custom_text_1 && item.establishment.custom_text_1.toLowerCase() === 'hôtel'"
                                        class="icon-list me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path
                                        d="M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm336 48l0 112 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-160 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96 160 0 0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
                                    {{ item.establishment.name|ellipsis(5) }}
                                </span>
              </div>
              <ReviewConsultantBox
                  v-if="item.establishment.consultant && parentPage == 'establishment'"
                  :avatar-src="backendUrl + item.establishment.consultant.avatar"
                  :fullname="item.establishment.consultant.fullname"
                  :justify-end="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && filtered_review_set.results.length === 0"
         class="d-flex align-items-start justify-content-center h-100">
      <div class="text-secondary text-center">
        <i class="fas fa-exclamation-triangle fa-2x"></i>
        <p class="mt-2">Aucun avis trouvé</p>
      </div>
    </div>
  </div>
</template>

<style>
.pad {
  padding: 0.75rem;
}

.list {
  overflow-y: scroll;

}
</style>
<script>
import gql from '@/gqlService.coffee';
import utils from '@/utils.js';
import settings from '@/settings.coffee';
import ReviewConsultantBox from '@/components/ReviewConsultantBox';

const reviewHeight = 117;

export default {
  name: 'ReviewListPaginated',
  components: {
    ReviewConsultantBox
  },
  props: {
    title: String,
    autoload: Boolean,
    height: String,
    filters: {
      type: Object
    },
    parentPage: {
      type: String,
      required: false
    }
  },
  data() {
    const vm = this;
    return {
      test: {a: null, b: 1},
      loading: true,
      review_set: new gql.DataHolder({
        handle_pagination: true,
        model: 'review_set_paginated',
        fields: 'uid total_count title_fr title_native author positive mark published_on establishment {uid name custom_text_1 consultant { fullname avatar } } platform {name} current_state {verbose_name, class_name, tag} answerer {uid lastname firstname fullname} has_game_set',
        filters: {establishment__active: true, current_state__class_name__neq: 'Classified'},
        autoload: vm.autoload
      }),
      backendUrl: settings.backendMediaUrl
    };
  },
  computed: {
    style() {
      return {
        height: this.height
      };
    },
    filtered_review_set() {
      let totalCount = 0;
      if (this.review_set.results.length > 0) {
        totalCount = this.review_set.results[0].total_count;
      }
      return {
        results: this.review_set.results,
        totalCount
      };
    },
    computed_filters() {
      const res = {};
      const f = this.filters;

      if (f.platform.uid) res.platform = f.platform;
      if (f.establishment.uid) res.establishment = f.establishment;
      if (f.consultant.uid) res["establishment__consultant__uid"] = f.consultant;
      if (f.search_string !== "") res.search_vector = f.search_string;
      if (f.sentiment) res.positive = f.sentiment.value;
      if (f.status) res["current_state__class_name"] = f.status.value;
      if (!f.classified) res["current_state__class_name__neq"] = "Classified";
      if (f.dateBeginFilter) res["published_on__gte"] = f.dateBeginFilter;
      if (f.dateEndFilter) res["published_on__lte"] = f.dateEndFilter;
      if (f.tag.name != null) res["current_state__tag__iexact"] = f.tag.code;
      if (f.has_game_filter) res.has_game_set = true;

      return res;
    }
  },
  methods: {
    keydown(e) {
      if (e.target.tagName !== 'TEXTAREA') {
        if (e.keyCode === 40 || e.keyCode === 38) e.preventDefault();
      }
    },
    keyup(e) {
      if (e.target.tagName !== 'TEXTAREA') {
        if (e.keyCode === 40) this.next();
        if (e.keyCode === 38) this.prev();
      }
    },
    next() {
      const self = this;
      let index = 0;
      for (const r of self.filtered_review_set.results) {
        if (r.uid === self.$store.state.selected_review_uid) break;
        index++;
      }

      if (index + 1 < self.filtered_review_set.results.length) {
        self.select(self.filtered_review_set.results[index + 1].uid);
      }

      const visible_objects = Math.floor(self.$refs.list.offsetHeight / reviewHeight);
      const to_scroll = index * reviewHeight - (visible_objects - 2) * reviewHeight;
      if (to_scroll > 0) {
        self.$refs.list.scroll(0, to_scroll);
      }
    },
    prev() {
      const self = this;
      let index = 0;
      for (const r of self.filtered_review_set.results) {
        if (r.uid === self.$store.state.selected_review_uid) break;
        index++;
      }

      if (index - 1 >= 0) {
        self.select(self.filtered_review_set.results[index - 1].uid);
      }

      const visible_objects = Math.floor(self.$refs.list.scrollTop / reviewHeight);
      const scrolled = self.$refs.list.scrollTop;
      const to_scroll = index * reviewHeight - (visible_objects + 2) * reviewHeight;
      if (to_scroll < 0) {
        self.$refs.list.scroll(0, scrolled + to_scroll);
      }
    },
    select(uid) {
      this.$router.push({
        name: 'team_detail',
        params: {uid}
      });

      let should_stop = false;
      for (const key in this.$store.state.edited_fields) {
        const f = this.$store.state.edited_fields[key];
        if (![null, ''].includes(f.value)) should_stop = true;
      }

      if (!should_stop) {
        this.$store.dispatch('select_review', uid);
      }
    },
    debug() {
      this.test.plop = 'plip';
    },
    async query() {
      this.loading = true;
      await this.review_set.query(this.computed_filters);
      this.loading = false;
    },
    debouncedQuery: utils.debounce(function () {
      this.query(this.computed_filters);
    }, 2000),
    get_class(state_name) {
      return [`state-${state_name.toLowerCase()}`];
    },
    get_tag_name(tag) {
      return tag ? this.$store.state.tag_name[tag.toLowerCase()] : null;
    },
    loadNextPage() {
      this.loading = true;
      this.review_set.load_next_page()
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    handleScroll(e) {
      if (e.srcElement.offsetHeight + e.srcElement.scrollTop === e.srcElement.scrollHeight) {
        this.loadNextPage();
      }
    },
    updateSearchString() {
      this.$emit('update-search-string', this.filters.search_string);
    }
  },
  async mounted() {
    const vm = this;

    this.review_set.promise.then(() => {
      vm.loading = false;
    });

    vm.$refs.list.addEventListener('scroll', this.handleScroll);

    if (this.$route.params.uid) {
      this.$store.dispatch('select_review', this.$route.params.uid);
    }

    window.addEventListener('keydown', vm.keydown, false);
    window.addEventListener('keyup', vm.keyup, false);
  },
  beforeDestroy() {
    const vm = this;
    window.removeEventListener('keydown', vm.keydown);
    window.removeEventListener('keyup', vm.keyup);
  },
  updated() {
    // logic if needed
  },
  watch: {
    filters(newV, oldV) {
      if (newV.search_string !== oldV.search_string) {
        this.debouncedQuery(newV);
      } else {
        this.query(newV);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.list {
  overflow-y: scroll;
  display: block;
}

.list-badge {
  overflow: hidden;
  display: block;
  // width: 9.5em;
  text-overflow: ellipsis;

}

.list-item {
  padding: 5px;
}

.list-item:hover {
  cursor: pointer;
}

svg.icon-list {
  max-height: 14px;
  line-height: 1;
  vertical-align: -.125em;
}

.selected {
  // border-radius:0.25rem;
  background-color: #eee;
}

.card-header-title {
  padding: 10px 0 10px 10px;
}

.card-header {
  height: 40px;
}

.state-name {
  width: calc(100% - 280px) !important;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  text-align: center;
  padding-top: 2px;
}

.tag-consultant {
  font-size: 0.8em;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*border:1px solid green;*/
  overflow: hidden;
  max-width: 70px;
  text-align: left;
  display: inline-block;
  padding-top: 4px;
}

.review-title {
  font-size: 0.8em;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  /*border:1px solid green;*/
  overflow: hidden;
  max-width: 35vw;
}

.author {
  height: 20px;
}

.card-header {
  padding: 0 !important;
  display: flex;
}

.tag {
  background-color: rgba(0, 0, 0, 0);
}

.custom-scroll {
  overflow: hidden;
  overflow-y: scroll;
  max-height: calc(100% - 50px);
}

.custom-badge {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 180px;
  float: right;
}

</style>
